/*----------------------------------
- GENERATED FILE
----------------------------------*/

// This file is generated by Proteum from client/pages/login/index.tsx.
// Do not edit it manually.

import type __GeneratedRouteApp from "@/client/index";

/*----------------------------------
- APP
----------------------------------*/

import AuthCard from '@/client/components/AuthCard';
import Page from '@/client/pages/_layout/_page';

/*----------------------------------
- CONTROLEUR
----------------------------------*/

export const __register = (app: __GeneratedRouteApp) => {
  const { Router } = app;
  return Router.page('/login', { ...({
  static: {
    refresh: '1h',
    urls: ['/login']
  }
}), ...{ filepath: "/app/client/pages/login/index.tsx", sourceLocation: { line: 13, column: 1 }, id: "login_index" } }, null, ({}) => <Page withLayout={false}>
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-pink-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="flex items-center justify-center gap-3 mb-4">
                        <img src="https://sitlmwrkxbvpqzfegvww.supabase.co/storage/v1/object/public/static/logoCP.png" alt="CrossPath Logo" className="w-12 h-12" />
                        <span className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">
                            CrossPath
                        </span>
                    </div>
                    <h1 className="text-2xl font-semibold text-gray-900 mb-2">Welcome back</h1>
                    <p className="text-gray-600">Sign in to your account</p>
                </div>

                <AuthCard mode="login" showModeTabs={false} showGoogleAuth={true} />

                <p className="text-center text-sm text-slate-600 mt-6">
                    Need an account?{' '}
                    <a href="/inbound/platform" className="text-orange-600 hover:text-orange-700 font-medium">
                        Create one here
                    </a>
                    .
                </p>
            </div>
        </div>
    </Page>);
};
